import { hot } from "react-hot-loader/root"
import { App } from "./App"
import { createRoot } from "react-dom/client"
import Modal from "react-modal"
import { initTelemetry } from "./initTelemetry"

initTelemetry()

const appEl = document.getElementById("wrap")
if (appEl) {
  Modal.setAppElement(appEl)
  const HotApp = hot(App)
  const root = createRoot(appEl)
  root.render(<HotApp />)
}
